// @ts-check

import { createContext, useContext, useEffect } from 'react';

/** @typedef {{ editor: import('@tiptap/core').Editor, defaultContent: string }} EditorContextType */

/** @type {import('react').Context<EditorContextType | null>} */
export const EditorContext = createContext(/** @type {EditorContextType | null} */ (null));

/** @returns {{ editor: import('@tiptap/core').Editor, defaultContent: string }} */
export const useWizzyEditor = () => {
	const context = useContext(EditorContext);

	if (!context) {
		throw new Error('useWizzyEditor must be used within a WizzyEditorProvider');
	}

	useEffect(() => {
		// Only set default content if editor is empty
		if (context.defaultContent && context.editor.isEmpty) {
			context.editor.commands.setContent(context.defaultContent);
		}
	}, [context.editor, context.defaultContent]);

	return context;
};
